import { container, title } from "../../material-kit-react";
import imagesStyle from "../../material-kit-react/imagesStyles";

const landingPageStyle = {
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    ...container
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none"
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0"
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  toc: {
    zIndex: 1000,
    position: 'fixed',
    top: '75px',
    right: '-150px',
    marginTop: '23px',
    marginBottom: '20px',
    paddingLeft: '10px',
    paddingRight: '10px',
    maxWidth: '45vw',
    width: '25vw',
    maxHeight: '70vh',
    overflow: 'auto',
    textAlign: 'inherit',
    '&:visited $a': {
      color: 'inherit'
    },
    '&:hover $a': {
      borderRadius: '1px black'
    }
  },
  tocLink: {
    '&:visited': {
      color: 'inherit'
    }
  },
  ...imagesStyle
};

export default landingPageStyle;
